// extracted by mini-css-extract-plugin
module.exports = {"button":"_1dMgA2"};